import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { RoutingPage, setPage } from '../../routes/routerSlice';
import ApplicationClosedOverlay from '../../components/global/ContentOverlay/ApplicationClosedOverlay';
import { MainContentWrapper } from '@ydistri/ds';
import { useAppDispatch } from '../../store';

const AsoScreen: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPage(RoutingPage.ASO));
  }, [dispatch]);

  return (
    <>
      <MainContentWrapper>
        <Outlet />
      </MainContentWrapper>
      <ApplicationClosedOverlay />
    </>
  );
};

export default AsoScreen;
